module.exports = __webpack_public_path__ + "img/202403_02.a824d873.jpg";